
export default function PageNotFound() {
    return (
        <div className="serviceErrorText">
            <h3>Service temporarily unavailable We apologize for this inconvenience. Please try again later.</h3>
        </div>
    )
}